var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFbIcon = function SvgFbIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36517 0.537842C3.32468 0.537842 0.0488281 3.8338 0.0488281 7.89909C0.0488281 11.5727 2.72395 14.6176 6.22224 15.172V10.0274H4.36371V7.89909H6.22224V6.27724C6.22224 4.43086 7.31468 3.4127 8.98517 3.4127C9.78566 3.4127 10.6242 3.55625 10.6242 3.55625V5.36657H9.69932C8.792 5.36657 8.5081 5.93491 8.5081 6.51724V7.89761H10.5357L10.2115 10.026H8.5081V15.1705C12.0064 14.6191 14.6815 11.5735 14.6815 7.89909C14.6815 3.8338 11.4057 0.537842 7.36517 0.537842Z",
    fill: "currentColor"
  })));
};
export default SvgFbIcon;